import React from "react";

const Animation = (animate_class, animate) => {
    let element = document.getElementsByClassName(animate_class);
    for (let i = 0; i < element.length; i++) {
        element[i].classList.add(animate); // add class of animate
    }
    setTimeout(()=>{
        for (let i = 0; i < element.length; i++) {
            if(element[i].classList.contains(animate)){element[i].classList.remove(animate)} // remove class of animate
        }
    },300)
}
export {Animation}